import { useCallback, useContext, useEffect, useRef, useState } from 'react'
import LayoutContext from '../../contexts/LayoutContext'
import { handleOverflow } from '../../utils/HandleOverflow'

export const useDrawerControls = () => {
  const onClickNext = useCallback((ref) => {
    const el = ref.current;
    el.classList.add('slide-in-active');
  },[])

  const onClickPrev = useCallback((ref) => {
    const el = ref.current;
    el.classList.remove('slide-in-active');
  }, [])

  return {
    onClickNext,
    onClickPrev
  }
}

export const useDrawerSubItem = (companyNavigation, item) => {
  const [items, setItems] = useState([])

  const slideRef = useRef();
  const currentSlug = `/${item.pageReference?.slug ?? item.slug}`
  const hasSubitems = item.subNavigationItems && item.subNavigationItems.length > 0
  const color = companyNavigation?.findIndex(el => el.id === item.id) !== -1 ? 'white' : 'black'

  useEffect(() => {
    let subItems = []
    if(item?.subNavigationItems) {
      subItems =  item?.subNavigationItems
    }
    if(item?.additionalReference) {
      subItems = [...subItems, ...item?.additionalReference]
    }
    setItems(subItems)
  }, [item])


  return {
    color,
    currentSlug,
    hasSubitems,
    items,
    slideRef
  }
}

export const useDrawer = (companyNavigation, profilNavigation) => {
  const [items, setItems] = useState([])

  const slideRef = useRef();

  const layoutState = useContext(LayoutContext)
  handleOverflow(layoutState.menuIsOpen)

  useEffect(() => {
    setItems([...companyNavigation, ...profilNavigation])
  },[companyNavigation,profilNavigation])


  return {
    items,
    layoutState,
    slideRef
  }
}